import { useEffect } from "react";
import Assignments from "../../components/AdminPortal/Assignment/Assignments";
import Header from "../../components/AdminPortal/Header/Header";
export default function Assignment() {
  useEffect(() => {
    document.title = "Assignment - LWS Learning Portal";
  }, []);
  return (
    <>
      <Header />
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-full px-5 lg:px-20">
          <Assignments />
        </div>
      </section>
    </>
  );
}
